const options = {
  5: "bg-pink-300/5",
  10: "bg-pink-300/10",
  25: "bg-pink-300/25",
  50: "bg-pink-300/50",
  75: "bg-pink-300/75",
  90: "bg-pink-300/90",
  100: "bg-pink-300",
};

const from = {
  5: "from-pink-300/5",
  10: "from-pink-300/10",
  25: "from-pink-300/25",
  50: "from-pink-300/50",
  75: "from-pink-300/75",
  90: "from-pink-300/90",
  100: "from-pink-300",
};

export default function getBackgroundPink300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
